import { Link } from 'components/Atoms/Link'
import { YolTokenButtonCSS } from './YolTokenButtonCSS.styled'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

export const YolTokenButton = () => {
  return (<></>
    // <YolTokenButtonCSS>
    //   <Link to={`/game/${CONTENT_TYPES.PUBLIC_PRESALE}`} className='yolotoken_header_link' type='button'>
    //     $YOLO PRESALE
    //   </Link>
    // </YolTokenButtonCSS>
  )
}
